jQuery(document).ready(function () {

    // overriding console.log in production
    if (window.location.host.indexOf('courttv.com') > 0) {
        console.log = function () {
        };
    }

    //all links external tab
    jQuery('a').each(function () {
        var a = new RegExp('/' + window.location.host + '/');
        if (!a.test(this.href)) {
            jQuery(this).click(function (event) {
                event.preventDefault();
                event.stopPropagation();
                window.open(this.href, '_blank');
            });
        }
    });

    jQuery(".home-slider li:not(.daily)").each(function () {
        var lnk = jQuery(this).find(".slide-link").attr("href");

        jQuery(this).click(function () {
            window.location.href = lnk;
        });

    });

    (function vDuty() {

        let title = document.querySelectorAll('h4.title a');
        let heading = document.querySelectorAll('.hero-content h1');
        let gridHeading = document.querySelectorAll('.shows-grid .heading h2');
        let slideHeading = document.querySelectorAll('.contained h3');

        function vReplace(el) {

            function checkForV(el) {
                for (var i = 0; i < el.length; i++) {
                    return el[i].innerHTML.includes('v' || 'V');
                }
            }

            if (checkForV(el)) {

                for (var i = 0; i < el.length; i++) {

                    el[i].innerHTML = el[i].innerHTML.replace('v.' || 'V.', '<i>v.</i>');
                }

            }
        }

        if (title != null || heading != null || gridHeading != null || slideHeading != null) {
            vReplace(title);
            vReplace(heading);
            vReplace(gridHeading);
            vReplace(slideHeading)
        }

    })();


    //header navigation & search toggles
    jQuery(".desktop-drawer .hamburger").click(function () {
        jQuery(".top-bar-right").toggleClass("drawer-active");
        jQuery(this).toggleClass("is-active");

    });

    jQuery(".mobile-nav-toggle .hamburger").click(function () {
        jQuery(".mobile-nav").toggleClass("active");
        jQuery(this).toggleClass("is-active");

    });

    jQuery(".search-toggle").click(function () {
        jQuery("#search-form").toggleClass("active");
        jQuery("#search-form input#search").focus();
    });
    //end navigation toggles

    jQuery("#nl_signup input[type=email]").focus(function () {
        jQuery("#g-recaptcha-newsletter").addClass("active");
    });

    jQuery(window).scroll(function () {
        var scroll = jQuery(window).scrollTop();

        if (scroll >= 80) {
            jQuery("header.header").addClass("fixed");
        } else if (!jQuery("body").hasClass("single-post") && !jQuery("body").hasClass("single-news")) {
            jQuery("header.header").removeClass("fixed");
        }

    });

    if (jQuery("body").hasClass("single-post") || jQuery("body").hasClass("single-news")) {
        jQuery("header.header").addClass("fixed");
    }


    //if DOM element in page, init slider
    if (jQuery(".anchors .glide")[0]) {
        var anchorGlide = new Glide('.anchors .glide', {
            // autoplay: 6000,
            type: 'slider',
            perView: 4,
            gap: 30,
            bound: true,
            breakpoints: {
                1024: {
                    perView: 3
                },
                640: {
                    perView: 1
                }
            }
        });

        anchorGlide.mount();

    }

    //if DOM element in page, init slider
    if (jQuery(".features .glide")[0]) {
        var featuresGlide = new Glide('.features .glide', {
            // autoplay: 6000,
            type: 'carousel',
            perView: 4,
            gap: 30,
            bound: true,
            breakpoints: {
                1024: {
                    perView: 3
                },
                640: {
                    perView: 1
                }
            }
        });

        featuresGlide.mount();

    }

    //if DOM element in page, init slider
    if (jQuery(".correspondents .glide")[0]) {
        var correspondentGlide = new Glide('.correspondents .glide', {
            // autoplay: 6000,
            type: 'slider',
            perView: 4,
            gap: 30,
            breakpoints: {
                1024: {
                    perView: 3
                },
                640: {
                    perView: 1
                }
            }
        });

        correspondentGlide.mount();

    }

    //if DOM element in page, init slider
    if (jQuery(".news-carousel .glide")[0]) {
        var carouselGlide = new Glide('.news-carousel .glide', {
            // autoplay: 6000,
            type: 'carousel',
            perView: 6,
            gap: 10,
            breakpoints: {
                1024: {
                    perView: 4
                },
                640: {
                    perView: 3
                }
            }
        });

        carouselGlide.mount();

        //lets see if we can handle the gallery click
        var $mainImg = jQuery("#galleryMainImage img");
        jQuery(".carousel-thumb img").on('click', function () {
            var $self = jQuery(this);
            //console.log("WE CLICKED ON IT");

            //console.log("--IMG",$img);
            var src = jQuery($self).attr("data-full-img");
            var caption = jQuery($self).attr("data-caption");
            //console.log("SRC",src);

            $mainImg.attr("src", src);
            $mainImg.attr("srcset", "");

            jQuery(".gallery-news-caption").text(caption);
        });

    }

    //if DOM element in page, init slider
    if (jQuery(".footer-slider.glide")[0]) {
        var footerGlide = new Glide('.footer-slider.glide', {
            autoplay: 6000,
            type: 'carousel',
            perView: 1
        });

        footerGlide.mount();

    }

    //Homepage specific
    if (jQuery("body").hasClass("home")) {
        //main hero slider
        var heroGlide = new Glide('.slides-container.glide', {
            autoplay: 6000,
            type: 'carousel'
        });
        heroGlide.mount();

        //homepage anchors slider
        var homeAnchorsGlide = new Glide('.anchors .glide', {
            type: 'slider',
            perView: 4,
            gap: 30,
            breakpoints: {
                1024: {
                    perView: 3
                },
                640: {
                    perView: 1
                }
            }
        });

        homeAnchorsGlide.on('mount.after', function () {
            jQuery(".anchors").hide();
        });

        //homeAnchorsGlide.mount();

        jQuery(".carousel-toggle li").click(function () {
            jQuery(".carousel-toggle li").removeClass("active");
            jQuery(".features, .anchors").hide();
            jQuery(this).addClass("active");
            jQuery("." + jQuery(this).data("carousel")).show();

        });
    }

    var nl_signup_container = document.querySelector('.nl_signup');

    function show_opt_in_message() {

        nl_signup_container.classList.add('-success');

        setTimeout(function () {
            nl_signup_container.classList.remove('-success');
        }, 4000);
    }

    function show_opt_in_error_message() {

        nl_signup_container.classList.add('-error');

        setTimeout(function () {
            nl_signup_container.classList.remove('-error');
        }, 4000);
    }

    function handle_newsletter_submit(e) {
        e.preventDefault();
        show_loading_screen('Submitting request&hellip;')
        var email_address = jQuery(e.target).find('[name=nl_signup_email]').val();

        var recaptcha_response = jQuery(e.target).find('[id=g-recaptcha-response]').val();
        var recaptcha_validate_url = window.location.protocol + "//" + window.location.host + "/wp-json/api/v1/validate_recaptcha_v2";

        if (recaptcha_response.length == 0) {
            jQuery(e.target).find(".display-notice").addClass('warning').html("Please click to verify reCAPTCHA").fadeOut(10000);
            hide_loading_screen();
            return;
        }

        jQuery.ajax({
            type: "POST",
            url: recaptcha_validate_url,
            data: {
                g_recaptcha_response: recaptcha_response
            }
        })
            .success(function (data) {
                console.log(data);

                if (data.success == true) {
                    // Add to MailChimp
                    var nl_data = {
                        nl_signup_email: email_address
                    };

                    jQuery.post('/', nl_data, function () {
                        show_opt_in_message();
                        hide_loading_screen();
                    }).fail(function (error) {
                        show_opt_in_error_message();
                        hide_loading_screen();
                    });
                }

            })
            .done(function () {
                hide_loading_screen();
            });

        return false;
    }

    jQuery("#nl_signup").submit(handle_newsletter_submit);

    /* Hack the style of the form submitted message to remove the white bar underneath. It has to wait for the form response to render, though. This is terrible, but deadlines is deadlines. */
    var has_form = jQuery('.form-wrapper').length;
    if (has_form) {
        var poll_for_form_submit;
        var $message;
        var $form_content;
        poll_for_form_submit = setInterval(function () {
            $form_content = jQuery(".ninja-forms-form-wrap");
            $message = $form_content.find(".nf-response-msg");
            if ($message && $message.html() && $message.html().length) {
                clearInterval(poll_for_form_submit);
                $form_content.closest('.form-wrapper').css({
                    'height': "0",
                    "padding": "0"
                });
            }
        }, 200);
    }
});

//  HIDE THE TRIANGLE / Delete or implement elsewhere
(function logoDuty() {
    var logoLink = document.getElementById('logo-link');

    window.onscroll = function () {
        if (window.pageYOffset > 25) {
            logoLink.classList.add('-invisible');
        } else {
            logoLink.classList.remove('-invisible');
        }
    };
})();

/* Display overlay indicating an asynchronous transaction is taking place */
function show_loading_screen(text) {
    jQuery('body').prepend('<div class="ajax_loader"><div class="spinner">' + text + '</div></div>')
}

function hide_loading_screen() {
    jQuery('.ajax_loader').remove();
}